<div class="container my-5" >
    <div class="row">
        <div class="col-12">
            <h1>Privacy Policy</h1>
            <p><strong>Effective date:</strong></p>
            <p>
                ChessX, Inc. ("us", "we", or "our") operates the chessx.ai website.
            </p>
            <p>
                This page informs you of our policies regarding the collection, use, and disclosure of
                personal data when you use our Service and the choices you have associated with that data.
                Our Privacy Policy is subject to our User Agreement and the other applicable agreements
                referenced therein.
            </p>
            <p>
                We use your data to provide and improve the Service. By using the Service, you agree to the
                collection and use of information in accordance with this policy. Unless otherwise defined in this
                Privacy Policy, terms used in this Privacy Policy have the same meanings as in our Terms and
                Conditions.
            </p>

            <h2>Definitions</h2>
            <h3>Service</h3>
            <p>
                Service means the chessx.ai website and the chessx.ai mobile application operated by
                ChessX, Inc., and any other products or services that we extend through chessx.ai or by
                other means. The Service does not include third-party content such as advertisements, or
                any other products or services offered by third parties. We do not and cannot control any
                third-party content, including user-generated content (for example, in-game chat content).
            </p>

            <h3>Personal Data</h3>
            <p>
                Personal Data means data about a living individual who can be identified from that data (or
                from that and other information either in our possession or likely to come into our
                possession). Personal data may also include "pseudonymous" data, meaning information
                about you which cannot be used to identify you personally - for example, an IP address, or
                information about which country from which you log into ChessX. For purposes of this
                Privacy Policy, all pseudonymous data is Personal Data to the extent that ChessX is a data
                processor of pseudonymous data.
            </p>

            <h3>Usage Data</h3>
            <p>
                Usage Data is data collected automatically either generated by the use of the Service or
                from the Service infrastructure itself (for example, the duration of a page visit). User Data
                may include pseudonymous data where applicable.
            </p>

            <h3>Cookies</h3>
            <p>
                Cookies are small pieces of data stored on your device (computer or mobile device).
            </p>

            <h3>Data Controller</h3>
            <p>
                Data Controller means the natural or legal person who (either alone or jointly or in common
                with other persons) determines the purposes for which and the manner in which any
                personal information is, or is to be, processed. For the purpose of this Privacy Policy, we are
                a Data Controller of your Personal Data and of your Usage Data.
            </p>

            <h3>Data Processors (or Service Providers)</h3>
            <p>
                Data Processor means any natural or legal person, including Service Providers, who
                processes the data on behalf of the Data Controller. We may use the services of various
                Data Processors in order to process your data more effectively. Any third party specifically
                referenced in this Privacy Policy, including Google (Alphabet, Inc.) and Facebook
                (Facebook, Inc., d/b/a Meta) is a third-party Data Processor within the meaning of this
                Privacy Policy.
            </p>

            <h3>Data Subject (or User)</h3>
            <p>
                Data Subject is any living individual who is using our Service and is the subject of Personal
                Data.
            </p>

            <h2>Information Collection And Use</h2>
            <p>
                We collect several different types of information for various purposes to provide and improve
                our Service to you.
            </p>

            <h2>Types of Data Collected</h2>

            <h3>Personal Data</h3>
            <p>
                While using our Service, we may ask you to provide us with certain personally identifiable
                information that can be used to contact or identify you ("Personal Data"). Personally
                identifiable information may include, but is not limited to:
            </p>
            <ul>
                <li>Required Information (chessx.ai username and either an email address, Google public ID, or Facebook
                    public ID)</li>
                <li>Optional Information (First name, last name, and other personal descriptors)</li>
                <li>Cookies and Usage Data</li>
                <li>Verification Information " Should you choose to apply on our platform for Verification, you will be
                    required to provide the following information: first and last name; date of birth; place of birth;
                    country; and a valid email address.</li>
            </ul>
            <p>
                We may use your Personal Data to contact you with newsletters, marketing or promotional
                materials, and other information that may be of interest to you. We do not sell your Personal
                Data or your Usage Data. Such data is for internal marketing purposes only. If you access
                ChessX through a web browser, your web browser may collect information about you and
                use it for advertising purposes or other purposes outside of our control. We do not and
                cannot store, manipulate, transfer, or sell any data which is collected or used by your web
                browser.
            </p>
            <p>
                If you use our App for the Android platform, we may ask, with your permission, to collect
                your contact list information (including potentially email addresses and phone numbers) to
                share with Google for the exclusive purpose of finding your friends and connections. We do
                not store this information. Similarly, if you use our App for the Apple platform, we may ask,
                with your permission, to collect your contact list information (including potentially email
                addresses and phone numbers) to share with Apple for the exclusive purpose of finding your
                friends and connections. We do not store this information.
            </p>
            <p>
                You may opt out of receiving any, or all, of these communications from us by following the
                unsubscribe link or instructions provided in any email we send or by contacting us.
            </p>

            <h3>Usage Data</h3>
            <p>
                We may also collect information that your browser sends to us whenever you visit our
                Service or when you access the Service by or through a mobile device ("Usage Data").
            </p>
            <p>
                This Usage Data may include information such as your computer's Internet Protocol address
                (e.g. IP address), browser type, browser version, the pages of our Service that you visit, the
                time and date of your visit, the time spent on those pages, unique device identifiers, and
                other diagnostic data.
            </p>
            <p>
                When you access the Service by or through a mobile device, this Usage Data may include
                information such as the type of mobile device you use, your mobile device unique ID, the IP
                address of your mobile device, your mobile operating system, the type of mobile Internet
                browser you use, unique device identifiers, and other diagnostic data.
            </p>

            <h3>Tracking Cookies Data</h3>
            <p>
                We use cookies and similar tracking technologies to track the activity on our Service and
                hold certain information.
            </p>
            <p>
                Cookies are files with small amounts of data which may include an anonymous unique
                identifier. Cookies are sent to your browser from a website and stored on your device.
                Tracking technologies also used are beacons, tags, and scripts to collect and track
                information and to improve and analyze our Service.
            </p>
            <p>
                You can instruct your browser to refuse all cookies or to indicate when a cookie is being
                sent. However, if you do not accept cookies, you may not be able to use some portions of
                our Service. Any Service, including paid Services or subscriptions to ChessX, may become
                unstable and non-functional if you do not accept cookies from ChessX.
            </p>
            <p>Examples of Cookies we use:</p>
            <ul>
                <li>Session Cookies. We use Session Cookies to keep you logged into our Service.</li>
                <li>Preference Cookies. We use Preference Cookies to remember your preferences and various settings.
                </li>
                <li>Security Cookies. We use Security Cookies for security purposes.</li>
                <li>Advertising Cookies. Advertising Cookies are used to serve you with advertisements that may be
                    relevant to you and your interests. You may opt out of the use of these cookies by visiting the
                    Google ad and content network privacy policy at <a href="http://www.privacychoice.org/companies"
                        target="_blank">http://www.privacychoice.org/companies</a> or <a
                        href="http://www.aboutads.info/choices" target="_blank">http://www.aboutads.info/choices</a>. To
                    learn more about this behavioral advertising practice or to opt-out of this type of advertising, you
                    can visit <a href="http://www.networkadvertising.org"
                        target="_blank">www.networkadvertising.org</a>. Google is a third-party Data Processor over whom
                    we have no control. We do not and cannot manage or control any data that Google processes on your
                    behalf.</li>
            </ul>

            <h2>Use of Data</h2>
            <p>ChessX, Inc. uses the collected data for various purposes:</p>
            <ul>
                <li>To customize the advertising and content you see</li>
                <li>To provide and maintain our Service</li>
                <li>To notify you about changes to our Service</li>
                <li>To allow you to participate in interactive features of our Service when you choose to do so</li>
                <li>To provide customer support</li>
                <li>To gather analysis or valuable information so that we can improve our Service</li>
                <li>To monitor the usage of our Service</li>
                <li>To detect, prevent and address technical issues</li>
                <li>To provide you with news, special offers and general information about other goods, services, and
                    events which we offer that are similar to those that you have already purchased or enquired about
                    unless you have opted not to receive such information</li>
                <li>To conduct research, and provide aggregated, anonymized reporting about our general user community
                    for internal and external clients</li>
                <li>Verification Information: Should you choose to apply on our platform for Verification, we will store
                    the information you provide in support of your application, and use that information to verify your
                    identity</li>
            </ul>
            <p>We do not sell your Personal Data to third parties.</p>

            <h2>Legal Basis for Processing Personal Data Under General Data Protection Regulation (GDPR)</h2>
            <p>If you are from the European Economic Area (EEA), ChessX, Inc.'s legal basis for collecting and using the
                personal information described in this Privacy Policy depends on the Personal Data we collect and the
                specific context in which we collect it.</p>
            <p>The purpose of this section of this policy is to explain how we ensure your privacy, what steps we take
                to prevent and mitigate the compromise of private information, what kinds of information we collect from
                you, what we do with that information, and how you may exercise certain of your rights under applicable
                data privacy laws related to that information. This policy identifies our data protection officer, and
                provides you with the information that you may need to contact our data protection officer.</p>
            <p>All terms of this Policy and our Terms of Use apply whether you log in via a browser or through an app
                native to a mobile device or any other device. Browser-based logins may be further subject to the terms
                of service (however styled) of your chosen browser. When using a browser-based login, your browser is a
                third-party within the meaning of the GDPR. When using our mobile app, your native app store, cell phone
                provider, data carrier, or other third parties may be third-party Data Collectors within the meaning of
                this Privacy Policy. We do not and cannot collect or store information that you submit to your web
                browser but not to us (for example, if you enter text into a text field on a browser-based login page,
                but do not click the Submit button or otherwise execute a command to send that information to us).</p>
            <p>ChessX, Inc. may process your Personal Data because:</p>
            <ul>
                <li>We need to perform a contract with you</li>
                <li>You have given us permission to do so</li>
                <li>For payment processing purposes</li>
                <li>To comply with the law</li>
            </ul>

            <h2>Retention of Data</h2>
            <p>ChessX, Inc. will retain your Personal Data only for as long as is necessary for the purposes set out in
                this Privacy Policy. We will retain and use your Personal Data to the extent necessary to comply with
                our legal obligations (for example, if we are required to retain your data to comply with applicable
                laws), resolve disputes, and enforce our legal agreements and policies, or until you instruct us to do
                otherwise in a fashion consistent with your rights (and our obligations) under the GDPR.</p>
            <p>ChessX, Inc. will also retain Usage Data for internal analysis purposes. Usage Data is generally retained
                for a shorter period of time, except when this data is used to strengthen the security or to improve the
                functionality of our Service, or we are legally obligated to retain this data for longer time periods.
            </p>

            <h2>Transfer Of Data</h2>
            <p>Your information, including Personal Data, may be transferred to and maintained on computers located
                outside of your state, province, country or other governmental jurisdiction where the data protection
                laws may differ than those from your jurisdiction.</p>
            <p>If you are located outside the United States and choose to provide information to us, please note that we
                transfer the data, including Personal Data, to the United States and process it there.</p>
            <p>Your consent to this Privacy Policy followed by your submission of such information represents your
                agreement to that transfer.</p>
            <p>ChessX, Inc. will take all steps reasonably necessary to ensure that your data is treated securely and in
                accordance with this Privacy Policy and no transfer of your Personal Data will take place to an
                organization or a country unless there are adequate controls in place including the security of your
                data and other personal information.</p>

            <h2>Disclosure Of Data</h2>
            <h3>Business Transaction</h3>
            <p>If ChessX, Inc. is involved in a merger, acquisition or asset sale, your Personal Data may be
                transferred. We will provide notice before your Personal Data is transferred and becomes subject to a
                different Privacy Policy.</p>

            <h3>Disclosure for Law Enforcement</h3>
            <p>Under certain circumstances, ChessX, Inc. may be required to disclose your Personal Data if required to
                do so by law or in response to valid requests by public authorities (e.g. a court or a government
                agency).</p>

            <h3>Legal Requirements</h3>
            <p>ChessX, Inc. may disclose your Personal Data in the good faith belief that such action is necessary to:
            </p>
            <ul>
                <li>To comply with a legal obligation</li>
                <li>To protect and defend the rights or property of ChessX, Inc.</li>
                <li>To prevent or investigate possible wrongdoing in connection with the Service</li>
                <li>To protect the personal safety of users of the Service or the public</li>
                <li>To protect against legal liability</li>
            </ul>

            <h2>Security Of Data</h2>
            <p>The security of your data is important to us, but remember that no method of transmission over the
                Internet, or method of electronic storage is 100% secure. While we strive to use commercially acceptable
                means to protect your Personal Data, we cannot guarantee its absolute security.</p>

            <h2>"Do Not Track" Signals</h2>
            <p>We do not support Do Not Track ("DNT"). Do Not Track is a preference you can set in your web browser to
                inform websites that you do not want to be tracked.</p>
            <p>You can enable or disable Do Not Track by visiting the Preferences or Settings page of your web browser.
                If you enable DNT functionality on any device, certain of the Services, including paid Services or
                ChessX subscriptions, may become unstable.</p>

            <h2>Your Data Protection Rights Under General Data Protection Regulation (GDPR)</h2>
            <p>If you are a resident of the European Economic Area (EEA), you have certain data protection rights.
                ChessX, Inc. aims to take reasonable steps to allow you to correct, amend, delete, or limit the use of
                your Personal Data.</p>
            <p>If you wish to be informed what Personal Data we hold about you and if you want it to be removed from our
                systems, please contact us.</p>
            <p>You can edit your ChessX account information at any time. In certain circumstances, you have the
                following data protection rights:</p>
            <ul>
                <li>The right to access, update or to delete the information we have on you. Whenever made possible, you
                    can access, update or request deletion of your Personal Data directly within your account settings
                    section. If you are unable to perform these actions yourself, please contact us to assist you.</li>
                <li>The right of rectification. You have the right to have your information rectified if that
                    information is inaccurate or incomplete.</li>
                <li>The right to object. You have the right to object to our processing of your Personal Data.</li>
                <li>The right of restriction. You have the right to request that we restrict the processing of your
                    personal information.</li>
                <li>The right to data portability. You have the right to be provided with a copy of the information we
                    have on you in a structured, machine-readable and commonly used format.</li>
                <li>The right to withdraw consent. You also have the right to withdraw your consent at any time where
                    ChessX, Inc. relied on your consent to process your personal information.</li>
            </ul>
            <p>Please note that we may ask you to verify your identity before responding to such requests.</p>
            <p>You have the right to complain to a Data Protection Authority about our collection and use of your
                Personal Data. For more information, please contact your local data protection authority in the European
                Economic Area (EEA).</p>

            <h2>Service Providers</h2>
            <p>
                We may employ third party companies and individuals to facilitate our Service ("Service
                Providers"), including Data Processors, to provide the Service on our behalf, to perform
                Service-related services or to assist us in analyzing how our Service is used.
            </p>
            <p>
                These third parties have access to your Personal Data only to perform these tasks on our
                behalf and are obligated not to disclose or use it for any other purpose.
            </p>

            <h3>Analytics</h3>
            <p>
                We may use third-party Service Providers to monitor and analyze the use of our Service.
            </p>
            <h4>Amplitude</h4>
            <p>
                Amplitude is a web analytics service that tracks and reports website traffic. It uses the data
                collected to track and monitor the use of our Service. For more information about Amplitude,
                including how to exercise your rights under the GDPR or the CCPA, please contact
                Amplitude directly at chessx. Amplitude is a third-party Data Processor within the meaning of
                this Privacy Policy.
            </p>

            <h3>Advertising</h3>
            <p>
                We may use third-party Service Providers to show advertisements to you to help support
                and maintain our Service.
            </p>
            <h4>Google AdSense DoubleClick Cookie</h4>
            <p>
                Google, as a third party vendor, uses cookies to serve ads on our Service. Google's use of
                the DoubleClick cookie enables it and its partners to serve ads to our users based on their
                visit to our Service or other websites on the Internet.
            </p>
            <p>
                You may opt out of the use of the DoubleClick Cookie for interest-based advertising by
                visiting the Google Ads Settings web page: <a
                    href="http://www.google.com/ads/preferences">http://www.google.com/ads/preferences</a>.
            </p>

            <h2>Payments</h2>
            <p>We may provide paid products and/or services within the Service. In that case, we use thirdparty services
                for payment processing (e.g. payment processors).</p>
            <p>
                We will not store or collect your payment card details. That information is provided directly to
                our third-party payment processors whose use of your personal information is governed by
                their Privacy Policy. These payment processors adhere to the standards set by PCI-DSS as
                managed by the PCI Security Standards Council, which is a joint effort of brands like Visa,
                Mastercard, American Express and Discover. PCI-DSS requirements help ensure the secure
                handling of payment information.
            </p>
            <p>The payment processors we work with are:</p>
            <ul>
                <li>
                    <strong>Apple Store In-App Payments</strong>
                    <br>Their Privacy Policy can be viewed at <a href="https://www.apple.com/legal/privacy/en-ww"
                        target="_blank" rel="noopener noreferrer">https://www.apple.com/legal/privacy/en-ww</a>
                </li>
                <li>
                    <strong>Google Play In-App Payments</strong>
                    <br>Their Privacy Policy can be viewed at <a href="https://www.google.com/policies/privacy"
                        target="_blank" rel="noopener noreferrer">https://www.google.com/policies/privacy</a>
                </li>
                <li>
                    <strong>Adyen</strong>
                    <br>Their Privacy Policy can be viewed at <a href="https://docs.adyen.com/legal/terms-conditions"
                        target="_blank" rel="noopener noreferrer">https://docs.adyen.com/legal/terms-conditions</a>
                </li>
                <li>
                    <strong>PayPal</strong>
                    <br>Their Privacy Policy can be viewed at <a
                        href="https://www.paypal.com/webapps/mpp/ua/privacy-full" target="_blank"
                        rel="noopener noreferrer">https://www.paypal.com/webapps/mpp/ua/privacy-full</a>
                </li>
            </ul>

            <h2>Appointment of the Data Protection Officer</h2>
            <p>
                ChessX's GDPR Data Protection Officer is Arun Mehta (the "Protection Officer"). The
                Protection Officer may be contacted at:
            </p>
            <ul>
                <li><strong>Phone:</strong></li>
                <li><strong>Email:</strong></li>
                <li><strong>Postal Address:</strong> xyz</li>
            </ul>

            <h2>Links To Other Sites</h2>
            <p>
                Our Service may contain links to other sites that are not operated by us. If you click on a
                third party link, you will be directed to that third party's site. We strongly advise you to review
                the Privacy Policy of every site you visit.
            </p>
            <p>
                We have no control over and assume no responsibility for the content, privacy policies or
                practices of any third party sites or services.
            </p>

            <h2>Children's Privacy</h2>
            <p>
                ChessX does not target anyone under the age of 13 ("Children") for use of our Service.
            </p>
            <p>
                We do not knowingly collect personally identifiable information from anyone under the age of
                13. If you are a parent or guardian and you are aware that your Children has provided us
                with Personal Data, please contact us. If we become aware that we have collected Personal
                Data from children without verification of parental consent, we take steps to remove that
                information from our servers.
            </p>
            <p>
                If you are a resident of the State of California or otherwise subject to the CCPA, please see
                below for important information regarding the privacy rights of Children using chessx.ai or
                any of the Services. If you are under the age of 13 and a resident of the State of California,
                you may not use chessx.ai or any of the Services.
            </p>
            <h2>Privacy Notice for California Residents</h2>
            <p>
                This Privacy Notice for California Residents supplements the information contained in our
                Privacy Policy and applies solely to all visitors, users, and others who reside in the State of
                California. We adopt this notice to comply with the California Consumer Privacy Act of 2018
                (CCPA). Any terms defined in the CCPA have the same meaning when used in this notice.
            </p>

            <h3>Your Rights and Choices</h3>
            <p>
                The CCPA provides consumers (California residents) with specific rights regarding their
                personal information. For purposes of the Privacy Notice for California Residents,
                personal information includes "Personal Data", "Usage Data", and "Cookies" as those terms
                are defined in this Privacy Policy. This section describes your CCPA rights and explains how
                to exercise those rights.
            </p>

            <h3>Access to Specific Information and Data Portability Rights</h3>
            <p>
                You have the right to request that we disclose certain information to you about our collection
                and use of your personal information over the past 12 months that is not otherwise subject to
                an exception under the CCPA.
            </p>

            <h3>Deletion Request Rights</h3>
            <p>
                You also have the right to request that we delete any of your personal information that we
                collected from you and retained, subject to certain exceptions.
            </p>

            <h3>Exercising Access, Data Portability, and Deletion Rights</h3>
            <p>
                To exercise the access, data portability, and deletion rights described above, please submit
                a verifiable consumer request to us by:
            </p>
            <ul>
                <li><strong>Phone:</strong></li>
                <li><strong>Email:</strong></li>
                <li><strong>Postal Address:</strong></li>
            </ul>
            <p>
                To be verifiable your request must:
            </p>
            <ul>
                <li>Provide sufficient information that allows us to reasonably verify you are the person
                    about whom we collected personal information or an authorized representative.</li>
                <li>Describe your request with sufficient detail that allows us to properly understand,
                    evaluate, and respond to it.</li>
            </ul>
            <p>
                We cannot respond to your request or provide you with personal information if we cannot
                verify your identity or authority to make the request and confirm the personal information
                relates to you.
            </p>
            <p>
                Only you, or a person registered with the California Secretary of State that you authorize to
                act on your behalf, may make a verifiable consumer request related to your personal
                information. You may also make a verifiable consumer request on behalf of your minor child.
            </p>

            <h3>Non-Discrimination</h3>
            <p>
                We will not discriminate against you for exercising any of your CCPA rights. Unless
                permitted by the CCPA, we will not: (i) deny you goods or services; (ii) charge you different
                prices or rates for goods or services, including through granting discounts or other benefits,
                or imposing penalties; (iii) provide you a different level or quality of goods or services; or (iv)
                suggest that you may receive a different price or rate for goods or services or a different
                level or quality of goods or services.
            </p>

            <h3>Selling Your Personal Information</h3>
            <p>We do not sell, and have not sold your personal information to third parties for a business or
                commercial purpose in the 12 months preceding the effective date of this Privacy Policy, as
                we understand the term "sell" to mean under the CCPA.</p>

            <h2>Personal Information we Collect, Use and Disclose</h2>
            <p>
                The CCPA specifies categories of personal information protected under the CCPA. The
                following chart provides information about the personal information we collect relative to
                each category and the sources from which we collect such data. For additional information
                regarding the personal information we collect and have collected in the 12 months preceding
                the effective date of our Privacy Policy see the heading "Types of Data Collected" of our
                Privacy Policy. We may use personal information for the business/commercial purposes
                described under the heading "Use of Data" of our Privacy Policy. For information about how
                we share your personal information see the headings "Disclosure of Data", "Service
                Providers", "Analytics" and "Advertising" of our Privacy Policy.
            </p>

            <div class="table-scroll-responsive">
                <table class="table table-striped table-bordered">
                    <thead>
                        <tr>
                            <th scope="col">Personal Information Category</th>
                            <th scope="col">PI we collect in this Category</th>
                            <th scope="col">Sources of PI</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr>
                            <td>Identifiers</td>
                            <td>
                                <ul>
                                    <li>A real name or alias</li>
                                    <li>Internet Protocol address(es)</li>
                                    <li>Email address</li>
                                    <li>Account name (username), or other similar identifier</li>
                                    <li>Mobile push tokens</li>
                                    <li>Specific third-party identifiers relating to chess services (e.g., USCF or FIDE
                                        ID
                                        number) may be collected for some accounts</li>
                                </ul>
                            </td>
                            <td>
                                <ul>
                                    <li>Information you provide us</li>
                                    <li>Information we collect from you automatically</li>
                                    <li>3rd Party Service Provider</li>
                                </ul>
                            </td>
                        </tr>
                        <tr>
                            <td>Personal information categories listed in the California Customer Records statute (Cal.
                                Civ.
                                Code "1798.80(e))</td>
                            <td>not applicable</td>
                            <td>not applicable</td>
                        </tr>
                        <tr>
                            <td>Protected classification characteristics under California or federal law</td>
                            <td>not applicable</td>
                            <td>not applicable</td>
                        </tr>
                        <tr>
                            <td>Commercial information</td>
                            <td>not applicable</td>
                            <td>not applicable</td>
                        </tr>
                        <tr>
                            <td>Biometric information</td>
                            <td>not applicable</td>
                            <td>not applicable</td>
                        </tr>
                        <tr>
                            <td>Internet or other similar network activity</td>
                            <td>
                                <ul>
                                    <li>Browsing history on chessx.ai only</li>
                                </ul>
                            </td>
                            <td>
                                <ul>
                                    <li>Information we collect from you automatically</li>
                                    <li>3rd Party Service Provider</li>
                                </ul>
                            </td>
                        </tr>
                        <tr>
                            <td>Geolocation data</td>
                            <td>not applicable</td>
                            <td>not applicable</td>
                        </tr>
                        <tr>
                            <td>Sensory data</td>
                            <td>not applicable</td>
                            <td>not applicable</td>
                        </tr>
                        <tr>
                            <td>Professional or employment-related information</td>
                            <td>not applicable</td>
                            <td>not applicable</td>
                        </tr>
                        <tr>
                            <td>Non-public education information (per the Family Educational Rights and Privacy Act (20
                                U.S.C. Section 1232g, 34 C.F.R. Part 99))</td>
                            <td>not applicable</td>
                            <td>not applicable</td>
                        </tr>
                        <tr>
                            <td>Inferences drawn from other personal information</td>
                            <td>not applicable</td>
                            <td>not applicable</td>
                        </tr>
                    </tbody>
                </table>
            </div>


            <h2>Contact Information</h2>
            <p>
                If you have any questions or comments about this notice or the ways in which ChessX, Inc.
                collects and uses your information as described in the Privacy Policy or you wish to
                exercise your rights under California law, please do not hesitate to contact us at:
            </p>
            <ul>
                <li><strong>Phone:</strong></li>
                <li><strong>Email:</strong></li>
                <li><strong>Postal Address:</strong></li>
            </ul>

            <h2>Changes to This Privacy Policy Notice</h2>
            <p>
                We reserve the right to amend our Privacy Policy at our discretion and at any time. When we
                make changes to our Privacy Policy, we will (i) let you know via email and/or a prominent
                notice on our Services and (ii) post the updated Privacy Policy on the website and update
                the Privacy Policy's effective date. You are advised to review this Privacy Policy periodically
                for any changes.
            </p>
            <p>
                Your continued use of our website following the posting of changes constitutes your
                acceptance of such changes.
            </p>

            <h2>Privacy Policy for Chess - Play & Learn (Arcade Version)</h2>
            <p>
                This section states our policy on the collection, use, and disclosure of data collected by the
                app, Chess - Play & Learn (Arcade Version), hereafter "the app." It is not broadly applicable
                to the ChessX website or its other apps.
            </p>
            <p>
                We do not collect any personal information through the app, but please review this policy for
                more detail on what kind of information may be collected, used and/or stored.
            </p>
            <p>
                If you choose to use the app, then you agree to the collection and use of information in
                relation to this policy. The information that we collect is used for supporting game services
                and improving the app. We will not use or share your information with anyone except as
                described in this Privacy Policy.
            </p>

            <h3>Data Collection and Use</h3>
            <p>
                The app collects non-identifiable gameplay data to send to Apple iCloud, specifically to
                record a player's progress (win record) vs the app's built-in roster of computer opponents.
                We (ChessX, Inc.) do not store any of this data, but it is sent to Apple services (iCloud and
                Game Center) for storage and use.
            </p>
            <p>
                The app also collects the user's anonymized gamePlayerID for the app's "Online Play"
                feature, where it is used exclusively to maintain a chess skill rating as online games are
                played. This helps ensure players are matched with opponents of similar skill levels. The
                collection of this data is subject to the user's explicit permission, as requested in the app
                prior to first use, and can be subsequently terminated at any time via the app's Settings
                ("Stop Collecting Data").
            </p>
            <p>
                The app is available to players of all ages through the Apple Arcade service and collects this
                non-identifiable gameplay data from all players without respect to age. The basis for this
                collection of information is to support the internal operations of the app as permitted by the
                Children's Online Privacy Protection Rule ("COPPA"), which is a legitimate use under the
                General Data Protection Regulation ("GDPR").
            </p>

            <h3>Security</h3>
            <p>
                We employ conventionally acceptable methods to protect all information we obtain from our
                users. However, no method of Internet transmission or of electronic storage is 100% secure
                and reliable, and we cannot absolutely guarantee its security.
            </p>

            <h3>Changes to This Privacy Policy</h3>
            <p>
                We may change our Privacy Policy from time to time, and we will notify you of any changes
                by posting updates to this page. These changes are effective immediately after they are
                posted here.
            </p>

            <h3>Contact Us</h3>
            <p>
                If you have any questions about our Privacy Policy, please
                <a routerLink="/contact-us">contact us</a>.
            </p>

        </div>
    </div>
</div>